__turbopack_context__.v({
  "container": "OrderAmountField-module-scss-module__kfsnyq__container",
});
